import type { ExplicitAddress } from '@cronos-app/sdk';
import { create } from 'zustand';

interface UseGraduateModal {
  isOpen: boolean;
  address: ExplicitAddress;
  closeModal: () => void;
  openModal: (address: ExplicitAddress) => void;
}

export const useGraduateModal = create<UseGraduateModal>((set) => ({
  isOpen: false,
  address: '',
  closeModal: () => {
    set({ isOpen: false, address: '' });
  },
  openModal: (address: ExplicitAddress) => {
    set({ isOpen: true, address });
  },
}));
